import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

import UtilSequence from "@/utils/UtilSequence.mjs";

export default {

    async criaParcela(parcelaValores = {}){

        let ordemDePagamentoParcela;

        try{

            //==================================================================//
            //====================== PREPARO DOS VALORES =======================//
            //==================================================================//

            parcelaValores = {
                descricao: parcelaValores?.descricao || "",
                dataCriacao: parcelaValores?.dataCriacao || "",
                dataDoPagamento: parcelaValores?.dataDoPagamento || "",
                tipo: "Faturamento",
                valor: parcelaValores?.valor || 0,
            };

            //==================================================================//
            //================= CRIA PARCELA ORDEM DE PAGAMENTO ===============//
            //==================================================================//

            ordemDePagamentoParcela = await ERP.postOne(Schema.ORDEM_DE_PAGAMENTO_PARCELAS, parcelaValores);
            if(ordemDePagamentoParcela.status != 200){
                throw ordemDePagamentoParcela;
            }

            console.log(ordemDePagamentoParcela);

        }catch(e){

            console.log(e);
            return ordemDePagamentoParcela;

        }

        return ordemDePagamentoParcela;

    },

    async criaParcelas(parcelasValores = []){

        let ordemDePagamentoParcelas = {
            data: [],
            status: 200
        };

        try{

            //==================================================================//
            //====================== PREPARO DOS VALORES =======================//
            //==================================================================//

            parcelasValores = parcelasValores.map((parcela = {}) => ({
                descricao: parcela?.descricao || "",
                dataCriacao: parcela?.dataCriacao || "",
                dataDoPagamento: parcela?.dataDoPagamento || "",
                tipo: "Faturamento",
                valor: parcela?.valor || 0,
            }));

            //==================================================================//
            //================ CRIA PARCELAS ORDEM DE PAGAMENTO ===============//
            //==================================================================//

            ordemDePagamentoParcelas.data = await UtilSequence.each({
                list: parcelasValores,
                callback: async (parcelaValores)=>{

                    let ordemDePagamentoParcela = await ERP.postOne(Schema.ORDEM_DE_PAGAMENTO_PARCELAS, parcelaValores);
                    if(ordemDePagamentoParcela.status != 200){
                        throw ordemDePagamentoParcela;
                    }

                    console.log(ordemDePagamentoParcela);

                    return ordemDePagamentoParcela.data;

                }
            });

        }catch(e){

            console.log(e);
            return ordemDePagamentoParcelas;

        }

        return ordemDePagamentoParcelas;

    },

    async alteraParcela(parcelaValores = {}){

        let ordemDePagamentoParcela;

        try{

            //==================================================================//
            //================ ALTERA PARCELA ORDEM DE PAGAMENTO ==============//
            //==================================================================//

            ordemDePagamentoParcela = await ERP.patchOne(Schema.ORDEM_DE_PAGAMENTO_PARCELAS, parcelaValores);
            if(ordemDePagamentoParcela.status != 200){
                throw ordemDePagamentoParcela;
            }

            console.log(ordemDePagamentoParcela);

        }catch(e){

            console.log(e);
            return ordemDePagamentoParcela;

        }

        return ordemDePagamentoParcela;

    },

    async alteraParcelas(parcelasValores = []){

        let ordemDePagamentoParcelas;

        try{

            //==================================================================//
            //=============== ALTERA PARCELAS ORDEM DE PAGAMENTO ==============//
            //==================================================================//

            ordemDePagamentoParcelas = await ERP.patchMany(Schema.ORDEM_DE_PAGAMENTO_PARCELAS, parcelasValores);
            if(ordemDePagamentoParcelas.status != 200){
                throw ordemDePagamentoParcelas;
            }

            console.log(ordemDePagamentoParcelas);

        }catch(e){

            console.log(e);
            return ordemDePagamentoParcelas;

        }

        return ordemDePagamentoParcelas;

    },

}